import React from "react";
import { useLocation } from "react-router-dom";

/**
 * Top spacer that pushes consumer-page content below the floating
 * BrandMark / TopMenu chips (each 44px tall + 12px top inset).
 *
 * Suppressed on:
 *   /           — landing route also mounts ScheduleSetup (map-first)
 *   /book       — booking sheet + map are full-bleed; the wizard
 *                  owns its own safe-area handling, and any spacer
 *                  here creates a blank band above the sheet on cold
 *                  PWA paint (fixed positioning is constrained by
 *                  the transformed RouterTransition ancestor, so the
 *                  spacer shifts the sheet down by its full height).
 *   /schedule   — map-first full-bleed layout owns its own top region
 *   /driver     — full-screen driver UI
 *   /admin/*    — admin pages have their own AdminTopNav
 */
export default function RouteTopSpacer() {
  const loc = useLocation();
  if (loc.pathname === "/") return null;
  if (loc.pathname === "/book") return null;
  if (loc.pathname.startsWith("/schedule")) return null;
  if (loc.pathname.startsWith("/driver")) return null;
  if (loc.pathname.startsWith("/admin")) return null;
  return (
    <div
      aria-hidden="true"
      style={{ height: "calc(env(safe-area-inset-top, 0px) + 100px)" }}
    />
  );
}
